import React from 'react';

function LoveLetter() {
  return (
    <div style={{
        background: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
      padding: '40px',
      fontFamily: 'Dancing Script, cursive', // Cursive font for romantic feel
      textAlign: 'center',
    }}>
      <h1 style={{
        fontSize: '50px',
        color: 'white', // Soft red color for the heading
        marginBottom: '20px',
      }}>
        A Love Letter to You 💌
      </h1>

      <p style={{
        fontSize: '20px',
        color: 'black',
        marginBottom: '40px',
        fontStyle: 'italic',
      }}>
        My dearest love,
      </p>

      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        fontSize: '22px',
        color: '#333',
        lineHeight: '1.6',
        textAlign: 'left',
        backgroundColor: '#fff',
        padding: '30px',
        borderRadius: '15px',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
      }}>
        <p>
          From the moment we met, I knew my life had changed forever. Every day spent with you feels like a beautiful dream come true. Your smile lights up my world and your love fills my heart in ways I never imagined possible.
        </p>

        <p>
          Together, we've shared so many precious memories—laughs, adventures, and quiet moments that I will cherish for the rest of my life. You make everything better, and you make me a better version of myself. I feel incredibly lucky to have you by my side.
        </p>

        <p>
          With you, I know that no matter what comes our way, we will always face it together. You are my heart, my love, and my forever. Every moment with you is a reminder of just how deeply I love you.
        </p>

        <p>
          I can't wait to spend the rest of my life with you, to create even more beautiful memories, and to continue falling more in love with you every single day.
        </p>

        <p style={{
          fontSize: '24px',
          fontStyle: 'italic',
          color: '#ff5e5b',
          marginTop: '40px',
        }}>
          Forever yours,
          <br />
          your girlfriend
        </p>
      </div>
    </div>
  );
}

export default LoveLetter;
